"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSectionToggledMiddleware = void 0;
const react_1 = __importDefault(require("react"));
const useSectionToggledMiddleware = () => {
    const subscriptionsRef = react_1.default.useRef([]);
    const add = (section, fn) => {
        subscriptionsRef.current.push([section, fn]);
    };
    const remove = (fn) => {
        subscriptionsRef.current = subscriptionsRef.current.filter((f) => f[1] !== fn);
    };
    const triggerSubscriptions = (section) => {
        subscriptionsRef.current.forEach(([_section, fn]) => {
            if (_section === section) {
                fn();
            }
        });
    };
    return {
        add,
        remove,
        triggerSubscriptions,
    };
};
exports.useSectionToggledMiddleware = useSectionToggledMiddleware;
